import { useNavigate, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Wind, Heart, Brain, Sparkles, ChevronLeft } from 'lucide-react';

const BreathingAppLandingPage = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: Wind,
      title: "6 Techniques Guidées",
      description: "Buteyko, Cohérence Cardiaque, 4-7-8, et plus"
    },
    {
      icon: Heart,
      title: "Défis Personnels",
      description: "Testez votre capacité pulmonaire et battez vos records"
    },
    {
      icon: Brain,
      title: "Suivi de Progression",
      description: "Historique complet de vos sessions et statistiques"
    },
    {
      icon: Sparkles,
      title: "Exercices Personnalisés",
      description: "Créez vos propres patterns de respiration"
    }
  ];

  return (
    <div 
      className="min-h-screen relative"
      style={{ background: 'linear-gradient(180deg, #0F2044 0%, #1a1a2e 60%, #0a1929 100%)' }}
    >
      {/* Content */}
      <div className="relative z-[3]">
        {/* Back to Home Link */}
        <div className="max-w-4xl mx-auto px-6 pt-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/80 hover:text-white font-medium transition-colors"
          >
            <ChevronLeft size={20} />
            Retour à l&apos;accueil
          </Link>
        </div>

      {/* Hero Section */}
      <div className="max-w-4xl mx-auto px-6 pt-12 pb-12 text-center">
        <div className="mb-8 flex justify-center">
          <div className="w-24 h-24 rounded-full bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center shadow-2xl shadow-cyan-500/30">
            <Wind className="w-12 h-12 text-white" />
          </div>
        </div>
        
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Respiration Santé
        </h1>
        <p className="text-xl text-white/80 mb-8 max-w-2xl mx-auto">
          Maîtrisez votre respiration avec des exercices guidés scientifiquement prouvés. 
          Réduisez le stress, améliorez votre sommeil et optimisez votre santé.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            onClick={() => navigate('/login')}
            className="px-8 py-6 text-lg rounded-full bg-cyan-500 hover:bg-cyan-600 shadow-lg shadow-cyan-500/30"
          >
            Commencer Gratuitement
          </Button>
        </div>
      </div>

      {/* Features Grid */}
      <div className="max-w-5xl mx-auto px-6 pb-20">
        <div className="grid md:grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <Card key={index} className="border-0 shadow-lg bg-white/10 backdrop-blur-md border-white/20">
              <CardContent className="p-6">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center mb-4">
                  <feature.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                <p className="text-white/70">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
      </div>
    </div>
  );
};

export default BreathingAppLandingPage;
